export default class Page {

    constructor(extended) {
        if (extended == null) { extended = {}; }
        this.extended = extended;
        this.isIn = false;

        this.config = $.extend({
            type:      'page',
            component: ''
        }, this.extended);
    }

    // Check if page is active
    is(slug) {
        // Returns true or false
        return $('body').hasClass(`${this.config.type}-${this.config.component}${slug}`);
    }

    in(slugs) {
        // Reset the bool
        this.isIn = false;
        // Make sure slugs is an array
        slugs = slugs instanceof Array ? slugs : [slugs];
        // Check each and return as the normal function
        slugs.forEach((slug) => {
            (slug => {
                if (this.is(slug)) { return this.isIn = true; }
            })(slug);
        });

        return this.isIn;
    }

    segment(id) {
        // Get segments
        let segments = window.location.pathname.split('/');
        // If segment is set
        if (segments[id] != null) {
            // Return requested segment
            return segments[id];
        } else {
            // Return false
            return false;
        }
    }

    segmentMatch(id, match) {
        // Shorthand segment check
        return (this.segment(id) === match);
    }
};
